import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Elaborator extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Elaborator'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: "",
      description: "",
      scenes: [],
      properties: {}
    }
  }
}

const servicePath = 'elaborators'
const servicePlugin = makeServicePlugin({
  Model: Elaborator,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin